module.exports = __webpack_public_path__ + "media/images/athletes/3523-08beba93ca7857366fd89c78c8c5ddc4.png";